import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(n,t)}function n(e,t){let n={};for(let[r,i]of e.entries()){let a=t(i,r,e);n[a]=i}return n}export{t as indexBy};
//# sourceMappingURL=indexBy-BwSvEDkk.js.map